// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_Profile__2B3Im .Profile_profile-container__eHcew {
  display: flex;
  flex-direction: column;
  background: var(--white);
  border-radius: 12px;
  position: relative;
  min-height: 400px;
}
@media (max-width: 1200px) {
  .Profile_Profile__2B3Im .Profile_profile-container__eHcew {
    margin-top: 24px;
  }
}
.Profile_Profile__2B3Im .Profile_profile-container__eHcew.Profile_is-loading__XlLr\\+ {
  padding: 24px;
}
.Profile_Profile__2B3Im .Profile_profile-container__eHcew.Profile_is-loading__XlLr\\+ .Profile_loader-container__ibB7M {
  padding: 0;
}

.Profile_loader-container__ibB7M {
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 260px);
  position: relative;
  padding: 24px;
}
.Profile_loader-container__ibB7M .Profile_fio-container__gtCX9 {
  display: initial;
}
.Profile_loader-container__ibB7M .Profile_fio-container__gtCX9 .Profile_loadingBlock__baFm4 {
  height: 29px;
}
.Profile_loader-container__ibB7M .Profile_info-list__GKnPn {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
  max-width: none;
  width: 50%;
}
.Profile_loader-container__ibB7M .Profile_info-list__GKnPn .Profile_loadingBlock__baFm4 {
  height: 18px;
}
.Profile_loader-container__ibB7M .Profile_Profile__cropModal__oqZDB {
  position: absolute;
  top: 0;
  right: -260px;
}
.Profile_loader-container__ibB7M .Profile_Profile__cropModal__oqZDB .Profile_loadingBlock__baFm4 {
  width: 240px;
  height: 240px;
}
@media (max-width: 768px) {
  .Profile_loader-container__ibB7M {
    max-width: initial;
  }
  .Profile_loader-container__ibB7M .Profile_info-list__GKnPn {
    width: initial;
  }
  .Profile_loader-container__ibB7M .Profile_Profile__cropModal__oqZDB {
    position: initial;
    margin: 12px auto 0;
    width: 100%;
    align-items: center;
    max-width: 304px;
    top: initial;
    right: initial;
  }
  .Profile_loader-container__ibB7M .Profile_Profile__cropModal__oqZDB .Profile_loadingBlock__baFm4 {
    width: 100%;
  }
}

.Profile_loadingBlock__baFm4 {
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/Profile.module.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AADJ;AAGI;EARF;IASI,gBAAA;EAAJ;AACF;AAEI;EACE,aAAA;AAAN;AAEM;EACE,UAAA;AAAR;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;AAKI;EACE,YAAA;AAHN;AAOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AALJ;AAOI;EACE,YAAA;AALN;AASE;EACE,kBAAA;EACA,MAAA;EACA,aAAA;AAPJ;AASI;EACE,YAAA;EACA,aAAA;AAPN;AAWE;EAvCF;IAwCI,kBAAA;EARF;EAUE;IACE,cAAA;EARJ;EAWE;IACE,iBAAA;IACA,mBAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,YAAA;IACA,cAAA;EATJ;EAWI;IACE,WAAA;EATN;AACF;;AAcA;EACE,kBAAA;AAXF","sourcesContent":[".Profile {\n\n  .profile-container {\n    display: flex;\n    flex-direction: column;\n    background: var(--white);\n    border-radius: 12px;\n    position: relative;\n    min-height: 400px;\n\n    @media (max-width: 1200px) {\n      margin-top: 24px;\n    }\n\n    &.is-loading {\n      padding: 24px;\n\n      .loader-container { \n        padding: 0;\n      }\n    }\n  }\n}\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  max-width: calc(100% - 260px);\n  position: relative;\n  padding: 24px;\n\n  .fio-container {\n    display: initial;\n\n    .loadingBlock {\n      height: 29px;\n    }\n  }\n\n  .info-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 12px;\n    max-width: none;\n    width: 50%;\n\n    .loadingBlock {\n      height: 18px;\n    }\n  }\n\n  .Profile__cropModal {\n    position: absolute;\n    top: 0;\n    right: -260px;\n\n    .loadingBlock {\n      width: 240px;\n      height: 240px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    max-width: initial;\n\n    .info-list {\n      width: initial;\n    }\n\n    .Profile__cropModal {\n      position: initial;\n      margin: 12px auto 0;\n      width: 100%;\n      align-items: center;\n      max-width: 304px;\n      top: initial;\n      right: initial;\n\n      .loadingBlock {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.loadingBlock {\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Profile": `Profile_Profile__2B3Im`,
	"profile-container": `Profile_profile-container__eHcew`,
	"is-loading": `Profile_is-loading__XlLr+`,
	"loader-container": `Profile_loader-container__ibB7M`,
	"fio-container": `Profile_fio-container__gtCX9`,
	"loadingBlock": `Profile_loadingBlock__baFm4`,
	"info-list": `Profile_info-list__GKnPn`,
	"Profile__cropModal": `Profile_Profile__cropModal__oqZDB`
};
export default ___CSS_LOADER_EXPORT___;
